/* loaded by smart-asset */
export default "Twitter~mqnObTGF.png"